export default __webpack_public_path__ + "media/PRICING.bfcc18251024bff34665b5a88287cfaf.mp4";